import React from 'react';
import { Drawer } from '../Drawer';
import { styled } from '@mui/material/styles';

export const MapDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: 'white',
    color: 'black',
    width: 435,
    borderTop: 'none',

    '@media (max-width: 768px)': {
      width: open ? '100vw' : '50px',
    },

    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      border: 'none',
      [theme.breakpoints.up('sm')]: {
        width: 50,
      },
      '@media (max-width: 768px)': {
        width: open ? '100vw' : '50px',
        [theme.breakpoints.up('sm')]: {
          width: 50,
        },
      },
    }),
  },
}));
